import { SHA3 } from 'sha3';
import api from './api';

export async function validateResetToken(token) {
  const response = await api.post('/validateResetToken', { jwt: token });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function sendResetRequest(username) {
  const response = await api.post('/sendPasswordReset', { username });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function resetPassword(token, password) {
  const response = await api.post('/resetPassword', {
    jwt: token,
    newpassword: new SHA3(256).update(password).digest('hex'),
  });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function changePassword(oldPassword, newPassword) {
  const response = await api.post('/changePassword', {
    oldpassword: new SHA3(256).update(oldPassword).digest('hex'),
    newpassword: new SHA3(256).update(newPassword).digest('hex'),
  });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}
